// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#publishpress-future-quick-edit {
    max-width: 340px;
    padding: 14px;
    border: 1px solid #ddd;
    margin-bottom: 20px;
}


#publishpress-future-quick-edit label {
    display: inline-block;
    max-width: 100%;
    line-height: 12px;
}

#post-expirator-quick-edit-wrapper .components-checkbox-control__label {
    line-height: 12px;
}
`, "",{"version":3,"sources":["webpack://./assets/jsx/workflow-manual-selection/quick-edit/css/style.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;;AAGA;IACI,qBAAqB;IACrB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["#publishpress-future-quick-edit {\n    max-width: 340px;\n    padding: 14px;\n    border: 1px solid #ddd;\n    margin-bottom: 20px;\n}\n\n\n#publishpress-future-quick-edit label {\n    display: inline-block;\n    max-width: 100%;\n    line-height: 12px;\n}\n\n#post-expirator-quick-edit-wrapper .components-checkbox-control__label {\n    line-height: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
